import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/layout/Header';
import { Footer } from '../../components/layout/Footer';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { MapPlaceholder } from '../../components/ui/MapPlaceholder';
import { Calendar, MapPin, Users, Search, List, Map as MapIcon, Filter } from 'lucide-react';
interface Event {
  id: string;
  title: string;
  date: string;
  location: string;
  participants: number;
  status: 'upcoming' | 'ongoing' | 'completed';
  category: string;
}
const eventsData: Event[] = [{
  id: '1',
  title: 'Aksi Bersih Pantai Ancol',
  date: '25 Feb 2025',
  location: 'Pantai Ancol, Jakarta Utara',
  participants: 150,
  status: 'upcoming',
  category: 'Clean-Up'
}, {
  id: '2',
  title: 'Workshop Pengelolaan Sampah Organik',
  date: '24 Feb 2025',
  location: 'Balai Kota Bandung',
  participants: 50,
  status: 'ongoing',
  category: 'Sosialisasi'
}, {
  id: '3',
  title: 'HPSN 2025: Parade Kostum Daur Ulang',
  date: '21 Feb 2025',
  location: 'Monas, Jakarta Pusat',
  participants: 500,
  status: 'completed',
  category: 'HPSN'
}, {
  id: '4',
  title: 'Webinar Ekonomi Sirkular',
  date: '28 Feb 2025',
  location: 'Online (Zoom)',
  participants: 300,
  status: 'upcoming',
  category: 'Sosialisasi'
}, {
  id: '5',
  title: 'Susur Sungai Ciliwung',
  date: '01 Mar 2025',
  location: 'Bogor - Jakarta',
  participants: 100,
  status: 'upcoming',
  category: 'Clean-Up'
}, {
  id: '6',
  title: 'Pelatihan Bank Sampah Unit',
  date: '15 Feb 2025',
  location: 'Surabaya',
  participants: 75,
  status: 'completed',
  category: 'Edukasi'
}];
export function EventAksiPage() {
  const [viewMode, setViewMode] = useState<'list' | 'map'>('list');
  const getStatusBadge = (status: Event['status']) => {
    switch (status) {
      case 'upcoming':
        return <Badge className="bg-blue-100 text-blue-700 hover:bg-blue-200 border-blue-200" data-id="element-3910">
            Akan Datang
          </Badge>;
      case 'ongoing':
        return <Badge className="bg-green-100 text-green-700 hover:bg-green-200 border-green-200" data-id="element-3911">
            Berlangsung
          </Badge>;
      case 'completed':
        return <Badge className="bg-gray-100 text-gray-700 hover:bg-gray-200 border-gray-200" data-id="element-3912">
            Selesai
          </Badge>;
    }
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col font-sans" data-id="element-3913">
      <Header data-id="element-3914" />

      <main className="flex-1" data-id="element-3915">
        {/* Hero Section */}
        <section className="bg-secondary-700 text-white py-16" data-id="element-3916">
          <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-3917">
            <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-3918">
              Event & Aksi Nasional
            </h1>
            <p className="text-lg text-secondary-100 max-w-2xl mx-auto" data-id="element-3919">
              Temukan dan ikuti kegiatan pengelolaan sampah di sekitarmu.
            </p>
          </div>
        </section>

        {/* Controls & Filters */}
        <section className="py-8 container mx-auto px-4 md:px-6" data-id="element-3920">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8" data-id="element-3921">
            {/* View Toggle */}
            <div className="flex bg-white rounded-lg p-1 border shadow-sm" data-id="element-3922">
              <button onClick={() => setViewMode('list')} className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${viewMode === 'list' ? 'bg-primary-50 text-primary-700' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-3923">
                <List className="h-4 w-4" data-id="element-3924" />
                Daftar Event
              </button>
              <button onClick={() => setViewMode('map')} className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${viewMode === 'map' ? 'bg-primary-50 text-primary-700' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-3925">
                <MapIcon className="h-4 w-4" data-id="element-3926" />
                Peta Lokasi
              </button>
            </div>

            {/* Search & Filter */}
            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto" data-id="element-3927">
              <div className="relative w-full sm:w-64" data-id="element-3928">
                <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-3929" />
                <Input placeholder="Cari event..." className="pl-9" data-id="element-3930" />
              </div>
              <Button variant="outline" className="gap-2 bg-white" data-id="element-3931">
                <Filter className="h-4 w-4" data-id="element-3932" />
                Filter
              </Button>
            </div>
          </div>

          {/* Content */}
          {viewMode === 'list' ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3933">
              {eventsData.map(event => <Card key={event.id} className="hover:shadow-md transition-shadow" data-id="element-3934">
                  <CardContent className="p-6" data-id="element-3935">
                    <div className="flex justify-between items-start mb-4" data-id="element-3936">
                      <Badge variant="outline" className="text-xs font-normal" data-id="element-3937">
                        {event.category}
                      </Badge>
                      {getStatusBadge(event.status)}
                    </div>

                    <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2" data-id="element-3938">
                      {event.title}
                    </h3>

                    <div className="space-y-3 text-sm text-gray-600 mb-6" data-id="element-3939">
                      <div className="flex items-center gap-2" data-id="element-3940">
                        <Calendar className="h-4 w-4 text-gray-400" data-id="element-3941" />
                        <span data-id="element-3942">{event.date}</span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-3943">
                        <MapPin className="h-4 w-4 text-gray-400" data-id="element-3944" />
                        <span className="line-clamp-1" data-id="element-3945">{event.location}</span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-3946">
                        <Users className="h-4 w-4 text-gray-400" data-id="element-3947" />
                        <span data-id="element-3948">{event.participants} Peserta</span>
                      </div>
                    </div>

                    <Link to={`/event/${event.id}`} className="w-full" data-id="element-3949">
                      <Button className="w-full bg-primary-600 hover:bg-primary-700 text-white" data-id="element-3950">
                        Lihat Detail
                      </Button>
                    </Link>
                  </CardContent>
                </Card>)}
            </div> : <div className="bg-white p-4 rounded-xl border shadow-sm h-[600px]" data-id="element-3951">
              <MapPlaceholder data-id="element-3952" />
            </div>}
        </section>
      </main>

      <Footer data-id="element-3953" />
    </div>;
}